import { Loader2 } from "lucide-react";
import { AdminAuthProvider, useAdminAuth } from "../context/AdminAuthContext";
import AdminLogin from "./admin/AdminLogin";
import AdminLayout from "./admin/AdminLayout";

function AdminGate() {
  const { loading, isAuthed } = useAdminAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-[#0A192F] flex items-center justify-center text-slate-300">
        <Loader2 className="animate-spin" />
      </div>
    );
  }
  return isAuthed ? <AdminLayout /> : <AdminLogin />;
}

export default function AdminApp() {
  return (
    <AdminAuthProvider>
      <AdminGate />
    </AdminAuthProvider>
  );
}
